import React from 'react';
import { AdminCrud } from './AdminCrud';
import { Badge } from '../../components/ui/badge';

const pub = (v) => (v ? <Badge className="bg-emerald-100 text-emerald-800 border-emerald-200" variant="outline">Published</Badge> : <Badge variant="outline" className="bg-slate-100 text-slate-600">Hidden</Badge>);

export default function AdminDirectory() {
  return (
    <AdminCrud
      title="Who Do I Call Directory"
      description="The public contact directory. Entries appear grouped by category. Mark true emergencies and add source links so residents can verify numbers."
      listEndpoint="/directory" createEndpoint="/directory" updateEndpoint="/directory" deleteEndpoint="/directory"
      searchKeys={['title', 'category', 'description', 'phone']}
      columns={[
        { key: 'title', label: 'Contact' },
        { key: 'category', label: 'Category' },
        { key: 'phone', label: 'Phone' },
        { key: 'emergency', label: 'Emergency', render: (i) => (i.emergency ? <Badge variant="outline" className="bg-red-50 text-red-800 border-red-200">Emergency</Badge> : '') },
        { key: 'published', label: 'Visible', render: (i) => pub(i.published !== false) },
      ]}
      fields={[
        { name: 'title', label: 'Contact name / service', type: 'text', placeholder: 'e.g. City of Kawartha Lakes — Municipal Services' },
        { name: 'category', label: 'Category (grouping heading on the public page)', type: 'text', placeholder: 'e.g. City Services, Utilities, Health, Emergency' },
        { name: 'description', label: 'Plain-language instructions (what this contact handles)', type: 'textarea', rows: 2 },
        { name: 'phone', label: 'Phone', type: 'text', placeholder: '705-324-9411' },
        { name: 'email', label: 'Email', type: 'text' },
        { name: 'url', label: 'Website / source link', type: 'text' },
        { name: 'emergency', label: 'Emergency contact (highlighted red)', type: 'switch', default: false },
        { name: 'featured', label: 'Featured (shown near the top)', type: 'switch', default: false },
        { name: 'order', label: 'Sort order (lower = higher)', type: 'number', default: 99 },
        { name: 'published', label: 'Published', type: 'switch', default: true },
      ]}
    />
  );
}
